import React from 'react'
import { SvgIcon } from '@material-ui/core'

function UnfoldSectionIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Vector 5'
        d='M16.4821 18.5004L12.0364 14.0547L7.59069 18.5004'
        fill='none'
        stroke='#444444'
        stroke-width='1.8'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        id='Vector 6'
        d='M7.5 5.49963L11.9457 9.94531L16.0543 5.49951'
        fill='none'
        stroke='#444444'
        stroke-width='1.8'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </SvgIcon>
  )
}

export default UnfoldSectionIcon
